<template>
    <div class="space-y-2">
        <h2 class="uppercase text-sm text-zinc-400">Lightness</h2>
        <ItemDropdown
            label="Number of Stops"
            v-model="selectNumberOfStops"
            :options="[
                {value: 5, label: '5'},
                {value: 7, label: '7'},
                {value: 11, label: '11'},
            ]"
        />
    </div>
</template>

<script>
import ItemDropdown from './ItemDropdown.vue'
import { store } from '../store.js'
import { computed } from 'vue'

export default {
    name: 'SectionLightness', 
    components: {
        ItemDropdown
    },
    setup() {
        const selectNumberOfStops = computed({
            get: () => store.numberOfStops,
            set: (value) => store.setNumberOfStops(value)
        })

        return {
            selectNumberOfStops
        }
    }
}
</script>